module.exports = __webpack_public_path__ + "static/citalia-25ab9dd6ba7f970a4e928d69dc19626b.jpg";